import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsNonBooleanDefault';
import { DownloadButton } from '../../../../utils/download';
import { UploadArea } from '../../../../utils/upload';
import { stepEndorsementsSchema } from '@swa_llow/pricing_engine';

class EndorsementsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upload: false,
        }
        this.uploadedEndorsements = this.uploadedEndorsements.bind(this);
    }

    uploadedEndorsements(results) {
        const { step } = this.props;
        this.setState({ upload: false });
        this.props.updateStep({
            ...step,
            items: results,
        });
    }

    render() {
        const { 
            selected_item_id,
            step,
            inputs,
            is_approved,
            errors,
            version,
        } = this.props;

        const { upload } = this.state;

        const { items = [] } = step;
        const count = items.length;

        return (
            <div>
                <div className="inputs-upload">
                    <div key={`full-buttons`} className="upload-buttons">
                        <button className="button small grey no-hover mr">Count : {count}</button>
                        <DownloadButton 
                            data={{
                                items,
                            }}
                            label={'Endorsements'}
                            file_name={`${step.key}.csv`}
                            type={'items'}
                            className={'mr'}
                        />
                        {!is_approved && <button className="button small secondary" onClick={() => this.setState({ upload: !this.state.upload })}>
                            <i className="fa fa-angles-up"></i>Upload Endorsements
                        </button>}
                    </div>
                    {upload &&
                        <div className="exclusions-edit">
                            <UploadArea
                                complete={this.uploadedEndorsements}
                                type='items' 
                            />
                        </div>
                    }
                </div>
                <ItemsEdit
                    version={version}
                    schema={stepEndorsementsSchema}
                    set_error={this.props.set_error}
                    updateStep={this.props.updateStep}
                    step={step}
                    inputs={inputs}
                    header={'Endorsements'}
                    description={'This section allows you to create quote endorsements (e.g. a car must be parked in a garage to be valid).'}
                    tag={'Endorsement'}
                    is_approved={is_approved}
                    errors={errors}
                    selected_item_id={selected_item_id}
                />
            </div>
        )
    }
}

export default EndorsementsEdit;